import { Injectable } from '@angular/core';
import {StateService} from '@core/services/state.service';

function BrowserOnly() {
  return function (
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ) {
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: any[]) {
      if (!StateService.isBrowser) {
        return;
      }
      return originalMethod.apply(this, args);
    };

    return descriptor;
  };
}

@Injectable({
  providedIn: 'root'
})

export class SectionObserverService {

  private observer: IntersectionObserver;

  constructor() {
      this.initObserver();
  }

  @BrowserOnly()
  private initObserver() {
    this.observer = new IntersectionObserver(this.onIntersection.bind(this), {
      root: null,
      threshold: 0,
      rootMargin: '10% 0px' // trigger callback when element is 10% outside the viewports height
    });
  }

  @BrowserOnly()
  observeElements(elements: { id: string, callback: () => void }[], showSkeleton = false) {
    elements.forEach(element => {
      const domElement = document.getElementById(element.id);
      if (domElement) {
        (domElement as any).callback = element.callback;
        this.observer.observe(domElement);
        if (showSkeleton) {
          domElement.classList.add('loading-skeleton'); // only available in web project
        }
      } else {
        console.warn(`${element.id} not found in DOM`);
      }
    });
  }

  @BrowserOnly()
  private async onIntersection(entries: IntersectionObserverEntry[]) {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        const element = entry.target as any;
        const callback = element.callback;
        if (callback) {
          delete element.callback;
          this.observer.unobserve(entry.target);
          await callback();
          element.classList.remove('loading-skeleton');
        }
      }
    }
  }

  // Always disconnect observer tp prevent mem leaks, call in onDestroy
  @BrowserOnly()
  disconnect() {
    this.observer.disconnect();
  }
}
